import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Success = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/dashboard/${id}`);
  }, [id, navigate]);

  return (
    <div>
    </div>
  );
};

export default Success;
